import { render, staticRenderFns } from "./ViewAllDealModal.vue?vue&type=template&id=61bb0c16&"
import script from "./ViewAllDealModal.vue?vue&type=script&lang=js&"
export * from "./ViewAllDealModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports